<template>
  <table>
    <tr v-for="(req,indexReq) in request_data">
      <td>
        {{indexReq}}
      </td>
      <td v-if="typeof req === 'object'">
        <request_data :request_data="req"></request_data>
      </td>
      <td v-else>
        {{req}}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "request_data",
  props: {
    request_data: null,
  },
  data() {
    return {
      expanded: false,
      selected: null
    };
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>